<template>

    <div class="grid-wrapper category">

        <div class="breadcumb">
            <nuxt-link v-for="(breadcrumbLink, i) in breadcrumbLinks"
                       :key="breadcrumbLink.url"
                       :to="buildUrl(breadcrumbLink)">
                {{ breadcrumbLink.name }} <span v-if="i < breadcrumbLinks.length - 1"> > </span>
            </nuxt-link>
        </div>

        <div class="banner-preview" v-if="category.banner">
            <img :src="category.banner" class="responsive" :alt="category.banner_alternative_text">

            <div class="short-description">
                <h1 class="title">
                    {{ category.name }}
                </h1>
                <p class="short-description-content" v-if="category.short_description">
                    {{ category.short_description }}
                </p>
            </div>

            <div class="design" v-if="category.design_by">
                Design by <u>{{ category.design_by }}</u>
            </div>
        </div>

        <div v-else style="margin-top: 40px;">
          <h1 class="title" >
            {{ category.name }}
          </h1>
        </div>

        <categories-list :categories="childrens"/>

    </div>

</template>

<script>
    import CategoriesList from '@/components/categories/CategoriesList.vue'
    import { getBreadcrumbFromPermalink } from '@/../shared/utils/utils'

    export default {
        name: 'category-header',
        components: { CategoriesList },
        props: {
            category: {
                type: Object,
                required: true
            }
        },
        computed: {
            breadcrumbLinks () {
                if (!this.category.permalink) { return }

                const names = getBreadcrumbFromPermalink(this.category.permalink).split(' / ')
                const pathElements = this.category.permalink.split('/')

                return names.map((name, i) => ({ name, permalink: pathElements.slice(0, i + 1).join('/') }))
            },
            childrens () {
                return this.category.childrens || []
            }
        },
        methods: {
            buildUrl(category) {
                return  "/categories/" + category.permalink
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/unstylished-headers.scss';
    @import '@/assets/stylesheets/variables.scss';

    .category {

        display: grid;

        grid-template-rows: repeat(4, auto);
        grid-gap: 10px;
        grid-auto-rows: min-content;
        font-family: "OpenSans Light";
        border-bottom: 1px solid #d5d5d5;
        margin-bottom: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;

        .banner-preview{
            position: relative;
            margin: 0 auto;

            img{
                width: 100%;
                max-height: 300px;

                @media only screen and (max-width: 992px) {
                    height: 270px;
                    object-fit: none; /* Do not scale the image */
                    object-position: center;
                }

                &.blank{
                    min-height: 200px;
                    background: #cccccc;
                }
            }

            .design{
                background: rgba(255, 255, 255, 0.8);
                padding: 5px 10px;

                font-family: OpenSans;
                font-size: 1.6rem;
                line-height: 1.38;
                letter-spacing: 0.8px;
                color: #000000;

                position: absolute;
                right: 0;
                bottom: 0;
            }

            .short-description{
                background: rgba(255, 255, 255, 0.8);
                padding: 10px 20px;
                width: 400px;
                height: fit-content;

                @media only screen and (max-width: 992px) {
                    width: 260px;
                    height: 100px;
                }

                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;

                font-family: OpenSans;
                font-size: 1.6rem;
                line-height: 1.38;
                letter-spacing: 0.8px;
                text-align: center;
                color: #626467;

                .short-description-content{
                    margin: 0;
                }

                @media only screen and (max-width: 992px) {
                    .short-description-content{
                        display: none;
                    }
                }
            }
        }

        .breadcumb {
            font-size: 14px;
            line-height: 1.36;
            letter-spacing: 0.34px;
            text-align: left;
            color: $color-gray;
        }

        .title {
            text-align: center;
        }
    }
</style>
